import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { LoggerService } from 'src/app/ax-commons-logger/logger/logger.service';
import {
  WorkEvent,
  WorkEventInvitation,
  WorkEventInvitationsService,
  WorkEventInvitationStatusEnum,
  WorkEventsService,
} from '../../../_generated/work-rest-api';

@Component({
  selector: 'app-events-admin-detail',
  templateUrl: './events-admin-detail.page.html',
  styleUrls: ['./events-admin-detail.page.scss'],
})
export class EventsAdminDetailPage implements OnInit {
  public event: WorkEvent;
  public eventInvitationsAccepted: WorkEventInvitation[] = [];
  public eventInvitationsDeclined: WorkEventInvitation[] = [];
  public eventInvitationsNotAnswered: WorkEventInvitation[] = [];
  public segment: 'teilnehmer' | 'optionen' = 'teilnehmer';
  public accordionStates: any = {};

  constructor(
    private activatedRoute: ActivatedRoute,
    private title: Title,
    private axEventsService: WorkEventsService,
    private axEventInvitationsService: WorkEventInvitationsService,
  ) {
  }

  async ngOnInit() {
    this.activatedRoute.params.subscribe(async data => {
      await this.loadData(data.id);
    });
  }

  ionViewDidEnter() {
    this.title.setTitle(`Veranstaltungs-Detail`);
  }

  /**
   * Initial data load. Can be repeated, e.g. via ion-refresher.
   *
   * @param eventId
   * @param refresherEvent
   */
  public async loadData(eventId: number, refresherEvent?) {
    this.event = await this.axEventsService.eventsV1ControllerFindById({ id: eventId }).toPromise();
    this.eventInvitationsAccepted = await this.axEventInvitationsService.eventInvitationsV1ControllerFindByEventId(
      { eventId, invitationStatus: WorkEventInvitationStatusEnum.Accepted }).toPromise();
    this.eventInvitationsDeclined = await this.axEventInvitationsService.eventInvitationsV1ControllerFindByEventId(
      { eventId, invitationStatus: WorkEventInvitationStatusEnum.Declined }).toPromise();
    this.eventInvitationsNotAnswered = await this.axEventInvitationsService.eventInvitationsV1ControllerFindByEventId(
      { eventId, invitationStatus: WorkEventInvitationStatusEnum.Unanswered }).toPromise();
    this.onLoadDataComplete(refresherEvent);
  }

  public async checkInToggle(event: { eventInvitation: WorkEventInvitation; checked: boolean }) {
    LoggerService.LOG(this, 'event', event);
    await this.axEventInvitationsService.eventInvitationsV1ControllerUpdate({
      id: event.eventInvitation.id, body: {
        checkInAt: event.checked ? new Date().toISOString() : null,
      },
    }).toPromise().then(async () => {
      this.eventInvitationsAccepted = await this.axEventInvitationsService.eventInvitationsV1ControllerFindByEventId({
        eventId: this.event.id,
        invitationStatus: WorkEventInvitationStatusEnum.Accepted,
      }).toPromise();
    });
  }

  /**
   * After Loading completed.
   *
   * @param refresherEvent
   * @private
   */
  private onLoadDataComplete(refresherEvent): void {
    if (refresherEvent) {
      refresherEvent.target.complete();
    }
  }
}
